import { Animal, Listing, MarketplaceProduct, Paginator, PetAge, ProductType } from 'shared/@types';
import { RequestClient } from 'shared/library/api-client';
import { getSafeLanguageCode } from 'shared/library/i18n/languages';
import { marketByLanguageCode } from 'shared/library/i18n/market';
import { PageRequestContext } from 'shared/library/page-builder';
import { apiRoute } from 'shared/library/api-route';

async function loadSellingADogPageData(req: RequestClient, ctx: PageRequestContext) {
  const language = getSafeLanguageCode(ctx.locale);
  const listingCountry = ctx.countryCode ?? marketByLanguageCode(language)?.country_code ?? 'SE';
  const [response, adults, products] = await Promise.all([
    req<{ listings: Paginator<Listing> }>(apiRoute('listings.index'), {
      format: 'card',
      animal: Animal.Dog,
      country: listingCountry,
      per_page: 8,
    }),
    req<{ listings: Paginator<Listing> }>(apiRoute('listings.index'), {
      format: 'card',
      animal: Animal.Dog,
      country: listingCountry,
      pet_age: PetAge.Adult,
      per_page: 2,
    }).catch(() => null),
    req<{ products: MarketplaceProduct[] }>(apiRoute('payments.products'), undefined, {
      'X-Country': listingCountry,
    }).catch(() => null),
  ]);
  const hasImage = (listing: Listing) => !!(listing.media_assets?.[0]?.url || listing.avatar?.url);
  const latestListings = response.listings.data.filter(hasImage);
  const adultListings = adults?.listings.data.filter(hasImage) ?? [];
  const examples = [...latestListings.slice(0, 2), ...adultListings, ...latestListings];
  const seenIds = new Set<number>();
  const data = examples
    .filter((listing) => {
      if (seenIds.has(listing.id)) return false;
      seenIds.add(listing.id);
      return true;
    })
    .slice(0, 4);

  return {
    listings: { ...response.listings, data },
    listingCountry,
    listingProduct:
      products?.products.find(
        (product) => product.product_type === ProductType.ListingPublishDog,
      ) ?? null,
  };
}

export { loadSellingADogPageData };
